export default "__VITE_ASSET__36ed48a6__"